"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Insights = _interopRequireDefault(require("../Insights"));

var _Slideshow = _interopRequireDefault(require("../Slideshow"));

var _MediaServiceVideo = _interopRequireDefault(require("../MediaServiceVideo"));

var _Image = _interopRequireDefault(require("./Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 84px;\n  height: 56px;\n  border: 1px solid #017acd;\n  cursor: pointer;\n\n  &:focus,\n  &:hover {\n    border: 1px solid #99caeb;\n    outline: 2px solid #000;\n  }\n\n  & img {\n    width: 84px;\n    height: 56px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n  width: 84px;\n  height: 56px;\n  border: 1px solid #abb2c1;\n  cursor: pointer;\n\n  &:focus,\n  &:hover {\n    border: 1px solid #99caeb;\n    outline: 2px solid #000;\n  }\n\n  & img {\n    width: 84px;\n    height: 56px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  & li {\n    display: inline-block;\n    margin-right: 4px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 48px;\n  margin-bottom: 40px;\n\n  @media screen and (max-width: 750px) {\n    padding: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 25%;\n  left: 25%;\n  width: 50%;\n  height: 50%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .hw-section-gallery-style h3,\n  .hw-section-gallery-style .HwCmd {\n    margin: 0.5em 0;\n    font-size: 1.375em;\n    line-height: 1.1em;\n    font-weight: normal;\n    color: #212121;\n  }\n\n  .hw-section-gallery-style .HwInfo,\n  .hw-section-gallery-style .HwVideo {\n    padding: 8px;\n    border: 1px solid #abb2c1;\n    line-height: 0;\n  }\n\n  .hw-section-gallery-style .HwInfo {\n    text-align: center;\n  }\n\n  .hw-section-gallery-style .HwInfo p,\n  .hw-section-gallery-style .HwVideo p {\n    padding: 0 8px;\n    line-height: 1.3em;\n    text-align: left;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper {\n    display: inline-block;\n    width: 50%;\n    padding: 8px;\n    box-sizing: border-box;\n    text-align: center;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper:only-of-type {\n    float: none;\n    width: 100%;\n  }\n\n  .hw-section-gallery-style .HwImageWrapper img {\n    max-width: 100%;\n  }\n\n  .hw-section-gallery-style .HwInfo .HwSection {\n    clear: both;\n  }\n\n  @media screen and (max-width: 750px) {\n    .hw-section-gallery-style .HwImageWrapper {\n      float: none;\n      width: 100%;\n    }\n\n    .hw-section-gallery-style .HwMedicalImage {\n      width: 100%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject());

var SvgVideoThumbnailOverlay = _styledComponents.default.svg(_templateObject2());

var SectionGallery = _styledComponents.default.section(_templateObject3());

var UlList = _styledComponents.default.ul(_templateObject4());

var ThumbnailButton = _styledComponents.default.button(_templateObject5());

var ActiveThumbnailButton = _styledComponents.default.button(_templateObject6());

var MediaGallery = /*#__PURE__*/function (_Component) {
  _inherits(MediaGallery, _Component);

  var _super = _createSuper(MediaGallery);

  function MediaGallery(props) {
    var _this;

    _classCallCheck(this, MediaGallery);

    _this = _super.call(this, props);
    _this.onThumbnailClick = _this.onThumbnailClick.bind(_assertThisInitialized(_this));
    _this.onSlideSelected = _this.onSlideSelected.bind(_assertThisInitialized(_this));
    _this.parseHtml = _this.parseHtml.bind(_assertThisInitialized(_this));
    _this.slideClass = 'mediaGallerySlide_';
    _this.insights = new _Insights.default();
    _this.state = {
      currentSlide: 0
    };
    return _this;
  }

  _createClass(MediaGallery, [{
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "getUrlFromDomString",
    value: function getUrlFromDomString(html) {
      var dom = this.parseHtml(html);
      var src = dom && dom.querySelector('img').getAttribute('src');
      var dotIndex = src.lastIndexOf('.');
      return src && src.substring(0, dotIndex) + '_tt' + src.substring(dotIndex);
    }
  }, {
    key: "onThumbnailClick",
    value: function onThumbnailClick(index, item) {
      var _this2 = this;

      var gallery = this.props.item;
      var galleryTypes = {
        hwVideo: 'video',
        hwSlideshow: 'slideshow',
        'Product Map': 'article',
        hwMedia: 'image'
      };
      var insightsObj = {
        pageName: document.title,
        eventName: 'galleryNav',
        galleryHwid: gallery.id,
        thumbnailType: galleryTypes[item.type],
        targetHwid: item.id,
        targetTitle: item.title.consumer,
        navIndex: index + 1,
        navItems: gallery.topics.length
      };
      this.insights.trackEvent(insightsObj);
      this.setState({
        currentSlide: index
      }, function () {
        // this focuses the slide on click, for accessibility/screen reader purposes
        _this2.slide.focus();
      }); // fire props callback

      this.props.onThumbnailClick(index + 1, item);
    }
  }, {
    key: "onSlideSelected",
    value: function onSlideSelected(index, item) {
      // fire props callback
      this.props.onSlideSelected(index, item);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          item = _this$props.item,
          mediaHash = _this$props.mediaHash,
          mediaServiceUrl = _this$props.mediaServiceUrl,
          mediaToken = _this$props.mediaToken;
      var onThumbnailClick = this.onThumbnailClick;
      var onSlideSelected = this.onSlideSelected;
      var itemList = item;

      if (item && item.topics) {
        var slides = [];
        var thumbnails = [];
        var currentSlide = itemList.topics.length > this.state.currentSlide ? this.state.currentSlide : 0;
        itemList.topics.forEach(function (item, i) {
          var activeThumbnail = currentSlide === i ? true : false;
          var userIndex = i + 1;

          switch (item.type) {
            case 'hwVideo':
              thumbnails.push( /*#__PURE__*/_react.default.createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react.default.createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: item.thumbnail,
                alt: "load video, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }), /*#__PURE__*/_react.default.createElement(SvgVideoThumbnailOverlay, {
                role: "presentation",
                focusable: "false",
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
              }, /*#__PURE__*/_react.default.createElement("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd"
              }, /*#__PURE__*/_react.default.createElement("rect", {
                fillOpacity: "0.8",
                fill: "#017ACD",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }), /*#__PURE__*/_react.default.createElement("g", {
                transform: "translate(12.5, 12.5)",
                fill: "#FAFAFA"
              }, /*#__PURE__*/_react.default.createElement("polygon", {
                points: "5 3.125 5 11.875 11.875 7.5"
              }))))) : /*#__PURE__*/_react.default.createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: item.thumbnail,
                alt: "load video, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }), /*#__PURE__*/_react.default.createElement(SvgVideoThumbnailOverlay, {
                role: "presentation",
                focusable: "false",
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
              }, /*#__PURE__*/_react.default.createElement("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd"
              }, /*#__PURE__*/_react.default.createElement("rect", {
                fillOpacity: "0.8",
                fill: "#017ACD",
                x: "0",
                y: "0",
                width: "40",
                height: "40"
              }), /*#__PURE__*/_react.default.createElement("g", {
                transform: "translate(12.5, 12.5)",
                fill: "#FAFAFA"
              }, /*#__PURE__*/_react.default.createElement("polygon", {
                points: "5 3.125 5 11.875 11.875 7.5"
              })))))));
              slides.push( /*#__PURE__*/_react.default.createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react.default.createElement(_MediaServiceVideo.default, {
                hideDisclaimer: true,
                item: item,
                mediaServiceUrl: mediaServiceUrl,
                mediaHash: mediaHash,
                mediaToken: mediaToken
              })));
              break;

            case 'hwSlideshow':
              var slideshowThumbSrc = _this3.getUrlFromDomString(item.html);

              thumbnails.push( /*#__PURE__*/_react.default.createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react.default.createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: slideshowThumbSrc,
                alt: "load slideshow, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              })) : /*#__PURE__*/_react.default.createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: slideshowThumbSrc,
                alt: "load slideshow, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }))));
              slides.push( /*#__PURE__*/_react.default.createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react.default.createElement(_Slideshow.default, {
                hideDisclaimer: true,
                item: item,
                onSlideSelected: onSlideSelected
              })));
              break;

            case 'hwMedia':
              var mediaThumbSrc = _this3.getUrlFromDomString(item.html);

              thumbnails.push( /*#__PURE__*/_react.default.createElement("li", {
                key: i
              }, activeThumbnail ? /*#__PURE__*/_react.default.createElement(ActiveThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: mediaThumbSrc,
                alt: "load image, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              })) : /*#__PURE__*/_react.default.createElement(ThumbnailButton, {
                type: "button",
                "aria-controls": "hwGallery_slide",
                onClick: function onClick() {
                  onThumbnailClick(i, item);
                }
              }, /*#__PURE__*/_react.default.createElement("img", {
                src: mediaThumbSrc,
                alt: "load image, ".concat(userIndex, " of ").concat(itemList.topics.length, " items")
              }))));
              slides.push( /*#__PURE__*/_react.default.createElement("div", {
                className: "slide",
                key: i
              }, /*#__PURE__*/_react.default.createElement(_Image.default, {
                hideDisclaimer: true,
                item: item
              })));
              break;

            default:
          }
        });
        return /*#__PURE__*/_react.default.createElement(SectionGallery, {
          className: "hw-section-gallery-style"
        }, /*#__PURE__*/_react.default.createElement(GlobalStyle, null), /*#__PURE__*/_react.default.createElement(UlList, {
          className: "ulist"
        }, thumbnails), /*#__PURE__*/_react.default.createElement("div", {
          id: "hwGallery_slide",
          "aria-live": "polite",
          tabIndex: "-1",
          ref: function ref(div) {
            _this3.slide = div;
          }
        }, slides[currentSlide]));
      } else {
        return null;
      }
    }
  }]);

  return MediaGallery;
}(_react.Component);

MediaGallery.propTypes = {
  item: _propTypes.default.object.isRequired,
  onThumbnailClick: _propTypes.default.func,
  mediaServiceUrl: _propTypes.default.string,
  mediaHash: _propTypes.default.string,
  mediaToken: _propTypes.default.string,
  onSlideSelected: _propTypes.default.func
};
MediaGallery.defaultProps = {
  onThumbnailClick: function onThumbnailClick() {},
  onSlideSelected: function onSlideSelected() {}
};
var _default = MediaGallery;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/MediaGallery/index.js